import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconCableErrorProps } from './IconCableError.types'
import * as Styled from './styles/IconCableError.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCableError: FC<IconCableErrorProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCableErrorProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconCableErrorProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M12.266 18.703c.55.926.101 1.735-1 1.735H3.734c-1.097 0-1.55-.81-1-1.735L6.5 12.137c.547-.899 1.45-.946 2 0ZM7.5 14.438v2.5'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M7.563 18.438a.062.062 0 0 1-.063.062.062.062 0 0 1-.063-.063c0-.035.028-.062.063-.062s.063.027.063.063ZM7 5.031c2.441 1.625 4.875 2.477 7 2.477h1.5m-.25 4.93h-.5c-1.613 0-3.227 0-5.578.874m6.328-2.804S5.75 10.39 4 11.516m11.5-2.078H14c-1.625 0-8.875-.657-11-2.407m18.5-1.515h-6V14.5h6'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconCableError
